import App from '../App';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
new App().start({
  hubless: true
});